import { createTheme } from "@mui/material/styles";
import type {} from "@mui/x-data-grid/themeAugmentation";
import { TOUCH_QUERY } from "./utils/useViewport";

const touchTarget = {
  [`@media ${TOUCH_QUERY}`]: { minWidth: 40, minHeight: 40 },
};

// Root MUI theme: component overrides only. No palette, typography or
// breakpoint changes — a palette here would repaint every default-blue button.
export const appTheme = createTheme({
  components: {
    MuiDialog: {
      styleOverrides: {
        // Phones: dialogs keep a 12 px margin and never outgrow the screen.
        paper: ({ theme }) => ({
          [theme.breakpoints.down("sm")]: {
            "&:not(.MuiDialog-paperFullScreen)": {
              margin: 12,
              width: "calc(100% - 24px)",
              maxWidth: "calc(100% - 24px)",
              maxHeight: "calc(100% - 24px)",
            },
          },
        }),
      },
    },
    // Small icon buttons, checkboxes and radios are 30-38 px: at least 40 px
    // on touch screens, whatever the icon size.
    MuiIconButton: {
      styleOverrides: {
        sizeSmall: touchTarget,
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        sizeSmall: touchTarget,
      },
    },
    MuiRadio: {
      styleOverrides: {
        sizeSmall: touchTarget,
      },
    },
    // Touch screens show every column's header buttons (sort, filter, menu).
    // They keep their own size instead of the 40 px above, and an unsorted
    // column's sort button, invisible there, leaves its room to the title: a
    // tap on the header still sorts, and sorted or filtered columns keep
    // their indicators.
    MuiDataGrid: {
      styleOverrides: {
        root: {
          [`@media ${TOUCH_QUERY}`]: {
            "& .MuiDataGrid-columnHeader .MuiIconButton-sizeSmall": {
              minWidth: "auto",
              minHeight: "auto",
            },
            "& .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeader--sorted) .MuiDataGrid-iconButtonContainer:has(.MuiDataGrid-sortIcon)":
              { display: "none" },
          },
        },
      },
    },
  },
});
